import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("ddms_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then(r => setUser(r.data))
      .catch(() => { localStorage.removeItem("ddms_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password, mfaCode = null) => {
    const { data } = await api.post("/auth/login", { username, password, mfa_code: mfaCode });
    if (data.mfa_required) {
      return { mfa_required: true };
    }
    localStorage.setItem("ddms_token", data.token);
    localStorage.setItem("ddms_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ddms_token");
    localStorage.removeItem("ddms_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
